import useInspection from "../../../hooks/inspections/useInspection";
import { InspectionPanelOnSiteContactInfoProps } from "./components/InspectionPanelOnSiteContactInfo";

export default function useInspectionPanelOnSiteContactInfo({
  id,
}: {
  id: string | number;
}): InspectionPanelOnSiteContactInfoProps {
  const { inspectionQuery } = useInspection({ id: id });

  const attributes = inspectionQuery.data?.data.attributes;
  const onSiteContactName = attributes?.onSiteContactName;
  const onSiteContactPhone = attributes?.onSiteContactPhone;
  const onSiteContactInstructions = attributes?.onSiteContactApplicantInstructions;

  return {
    name: onSiteContactName,
    phone: onSiteContactPhone,
    instructions: onSiteContactInstructions,
  };
}
